import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { Server } from "../../../constants";
import '../css/styles.css'
import { Col, Row, Form, Button } from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import { FiChevronDown, FiChevronUp, FiDownload, FiSend } from 'react-icons/fi';
import { FaFileAlt } from 'react-icons/fa';
import { MdBuild } from 'react-icons/md';
import cuid from "cuid";
import { CSSTransition } from 'react-transition-group';
import { FiCheckCircle } from 'react-icons/fi';
import Swal from 'sweetalert2';
import LogoHyundai from "../assets/hyundai-logo.png";
import { validarCedula, validarEmail, validarTelefono, validarNombre } from '../../../services/functions';
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Image, pdf } from '@react-pdf/renderer';
import FooterImage from '../assets/barra.jpg'
import { FaAngleLeft } from 'react-icons/fa';
import { useCallback } from 'react';
import Tucson from '../assets/tucson.png'
import Kona from '../assets/kona.png'
import Staria from '../assets/staria.png'


const Step3 = ({ modeloVehiculo, mantenimientosSeleccionados, modeloAgrupador, mantenimiento, placa, codigoModeloYear, periodo, updatePonyDialog, updateLockMessage, handleStepClick }) => {
  const [total, setTotal] = useState(0);
  const [beneficios, setBeneficios] = useState(0);
  const [beneficiosData, setBeneficiosData] = useState([]);
  const [totalSinBeneficios, setTotalSinBeneficios] = useState(0);
  const [totalConBeneficios, setTotalConBeneficios] = useState(0);
  const [totalBeneficiosAdicionales, setBeneficiosAdicionales] = useState(0);
  const [showDetails, setShowDetails] = useState(false);
  const [mantenimientosFiltrados, setMantenimientosFiltrados] = useState([]);
  const [showMaintDetails, setShowMaintDetails] = useState(false);
  const [totalMantenimientos, setTotalMantenimientos] = useState(0);
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [identificacion, setIdentificacion] = useState("");
  const [telefono, setTelefono] = useState("");
  const [asesor, setAsesor] = useState("");
  const [enviado, setEnviado] = useState(false);
  const [datosPDF, setDatosPDF] = useState(null);
  const [nombreError, setNombreError] = useState('');
  const [identificacionError, setIdentificacionError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [telefonoError, setTelefonoError] = useState('');
  const [formularioEnviado, setFormularioEnviado] = useState(false);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [totalSinBeneficiosDes, setTotalSinBeneficiosDes] = useState(0);
  const [suggestions, setSuggestions] = useState([]);
  const [focusedSuggestionIndex, setFocusedSuggestionIndex] = useState(-1);
  //const [porDesMantenimiento, setPorDesMantenimiento] = useState(0);

  const domains = ['gmail.com', 'hotmail.com', 'yahoo.com', 'outlook.com'];

  const handleNuevaCotizacion = () => {
    handleStepClick(1)

  };

  const yourBackFunction = () => {
    handleStepClick(2)
  };

  const handleNombreChange = (e) => {
    const inputValue = e.target.value;
    if (!/^[\p{L} ]+$/gu.test(inputValue)) {
      return;
    }
    if (nombreError && validarNombre(inputValue)) {
      setNombreError('');
    }
    setNombre(inputValue);
  };

  const handleNombreBlur = () => {
    if (!validarNombre(nombre)) {
      setNombreError('Por favor, introduce un nombre válido.');
    } else {
      setNombreError('');
    }
  };

  const handleEmailChange = (e) => {
    const inputValue = e.target.value;
    if (emailError && validarEmail(inputValue)) {
      setEmailError('');
    }

    if (!inputValue.includes('@')) {
      setSuggestions([]);
    } else {
      const [, domainPart] = inputValue.split('@');
      if (!domainPart) {
        setSuggestions(domains);
      } else {

        setSuggestions(
          domains.filter(domain => domain.startsWith(domainPart))
        );
      }
    }
    setFocusedSuggestionIndex(-1);
    setEmail(inputValue);
  };


  const selectSuggestion = (suggestion) => {
    setEmail(email.split('@')[0] + '@' + suggestion);
    setSuggestions([]);
  };

  const handleEmailKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      const nextIndex = focusedSuggestionIndex + 1;
      setFocusedSuggestionIndex(nextIndex >= suggestions.length ? 0 : nextIndex);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const prevIndex = focusedSuggestionIndex - 1;
      setFocusedSuggestionIndex(prevIndex < 0 ? suggestions.length - 1 : prevIndex);
    } else if (e.key === "Enter" && focusedSuggestionIndex >= 0) {
      selectSuggestion(suggestions[focusedSuggestionIndex]);
    }
  };

  const handleEmailBlur = () => {
    if (!validarEmail(email)) {
      setEmailError('Por favor, introduce un email válido.');
    } else {
      setEmailError('');
    }
  };

  const handleIdentificacionChange = (e) => {
    const inputValue = e.target.value;
    if (isNaN(inputValue)) {
      return;
    }
    if (identificacionError && validarCedula(inputValue)) {
      setIdentificacionError('');
    }
    setIdentificacion(inputValue);
  };

  const handleIdentificacionBlur = () => {
    if (!validarCedula(identificacion)) {
      setIdentificacionError('Por favor, introduce un número de cédula válido.');
    } else {
      setIdentificacionError('');
    }
  };

  const handleTelefonoChange = (e) => {
    const inputValue = e.target.value;
    if (!/^\d*$/.test(inputValue)) {
      return;
    }
    setTelefono(inputValue);
  };

  const handleTelefonoBlur = () => {
    if (!validarTelefono(telefono)) {
      setTelefonoError('Telefono inválido. Ej. Fijo: 022662281/Cel: 0983055789');
    } else {
      setTelefonoError('');
    }
  };

  ////obtener beneficios/////
  const obtenerBeneficios = useCallback(async (cantidadMantenimientos, setBeneficiosData) => {
    let cantidadMantenimientosApi = cantidadMantenimientos;
    if ([5, 7, 9, 11].includes(cantidadMantenimientos)) {
      cantidadMantenimientosApi -= 1;
    }
    const beneficios = await axios.get(`${Server}/api/mprepagados/beneficios1/${modeloVehiculo.MP_VER_KM}/${cantidadMantenimientosApi}/${modeloVehiculo.MP_TIPO}`);
    setBeneficiosData(beneficios.data);

    let benAdicionales = 0;
    const totalBeneficios = beneficios.data.reduce((total, beneficio) => {
      const monto = Number(beneficio.BT_TOTAL);
      if (['BONO 1', 'BONO 2'].includes(beneficio.BT_CODIGO)) {
        benAdicionales += monto;
        return total;
      }
      return total + monto;
    }, 0);

    return { totalBeneficios, benAdicionales };
  }, [modeloVehiculo.MP_TIPO, modeloVehiculo.MP_VER_KM]);

  ///obtener datos mantenimientos
  const obtenerDatosMantenimientos = useCallback(async () => {
    let MP_VER_KM = codigoModeloYear ? periodo : modeloVehiculo.MP_VER_KM;
    const url = `${Server}/api/mprepagados/disponibles/${modeloVehiculo.MP_VER_CODIGO}`;
    try {
      const response = await axios.get(url);
      const factor = MP_VER_KM === '7k' ? 7500 : 5000;
      const seleccionadosTransformados = Array.from(mantenimientosSeleccionados).map(m => String(m * factor));

      const filtrados = response.data.filter(m => seleccionadosTransformados.includes(m.BT_KM));
      setMantenimientosFiltrados(filtrados);

      const totalMantenimientos = filtrados.reduce((acc, m) => acc + Number(m.BT_PVP_TOTAL), 0);
      setTotalMantenimientos(totalMantenimientos);

      // obtener beneficios y adicionales
      const { totalBeneficios, benAdicionales } = await obtenerBeneficios(mantenimientosSeleccionados.size, setBeneficiosData);
      const beneficiosConIva = totalBeneficios * 1.15;
      const beneficiosRedondeados = Math.round(totalBeneficios * 100) / 100;
      setBeneficios(beneficiosRedondeados);

      const resultadoRedondeado = Math.round(totalMantenimientos * 1.15 * 100) / 100;
      setTotalSinBeneficios(resultadoRedondeado);

      const benAdicionalesFi = benAdicionales * 1.15;
      setBeneficiosAdicionales(benAdicionales); // Ahora sí lo seteas correctamente

      const totalConBeneficios = resultadoRedondeado + benAdicionalesFi;
      setTotalConBeneficios(totalConBeneficios);

      setTotalSinBeneficiosDes(beneficiosConIva);

      const totalFinal = totalMantenimientos - totalBeneficios;
      setTotal(totalFinal * 1.15);

      // Solo para ver en consola los valores reales
      console.log("Beneficios sin IVA:", totalBeneficios);
      console.log("Beneficios adicionales sin IVA:", benAdicionales);
      console.log("Mantenimientos con IVA:", resultadoRedondeado);
      console.log("Total con beneficios:", totalConBeneficios);
    } catch (err) {
      console.log(err);
    }
  }, [codigoModeloYear, periodo, modeloVehiculo, mantenimientosFiltrados, mantenimientosSeleccionados, obtenerBeneficios]);

  useEffect(() => {
    obtenerDatosMantenimientos();
  }, []);

  const toggleMaintDetails = () => {
    setShowMaintDetails(!showMaintDetails);
  };


  const guardarCotizacionPrepagados = async () => {
    const url = `${Server}/api/mprepagados/cotizacion/guardar`;
    let cid = cuid();
    const dataForm = new FormData();
    const mantenimientos = mantenimientosFiltrados.map(mantenimiento => mantenimiento.BT_KM);
    const mantenimientosString = mantenimientos.join(',');
    dataForm.append("CLT_IDENTIFICACION", identificacion);
    dataForm.append("CLT_NOMBRE", nombre);
    dataForm.append("CLT_CORREO", email);
    dataForm.append("CLT_TELEFONO", telefono);
    dataForm.append("CTZ_PVP_MANT", totalSinBeneficios.toFixed(2));
    dataForm.append("CTZ_PVP_BENEFICIOS", (beneficios * 1.15).toFixed(2));
    dataForm.append("CTZ_PVP_FINAL", total.toFixed(2));
    dataForm.append("CTZ_DESC_PERCENT", (((totalSinBeneficios - total) / totalSinBeneficios) * 100).toFixed(2));
    dataForm.append("CTZ_PACK_MTN", mantenimientosString);
    dataForm.append("CTZ_MODELO", modeloAgrupador);
    dataForm.append("CTZ_KM", modeloVehiculo.MP_VER_KM);
    dataForm.append("CTZ_PLACA", placa);
    dataForm.append("CTZ_ASESOR", asesor);
    dataForm.append("CTZ_CODIGO", cid);

    for (let pair of dataForm.entries()) {
      console.log(pair[0] + ', ' + pair[1]);
    }
    try {
      const response = await axios.post(url, dataForm);
      if (response.status === 200) {
        console.log("Datos guardados correctamente");
      }
    } catch (error) {
      console.error("Hubo un error al guardar los datos: ", error);
    }
    setFormularioEnviado(true);
  }


  const guardarCotizacion = async () => {
    await guardarCotizacionPrepagados();
    // Mostrar SweetAlert
    Swal.fire(
      'Cotización Enviada',
      'Tu cotización ha sido enviada con éxito.',
      'success'
    );
    setEnviado(true);
    updatePonyDialog("🎉 Felicidades, completaste el proceso! 🎉");
    updateLockMessage(true)
  };

  let showDetailsTable = beneficiosData.map((row) =>
  ({
    codigo: row.BT_DESCRIPCION,
    total: row.BT_TOTAL,
    items: row.CANTIDAD
  }));

  let showMaintDetailsTable = mantenimientosFiltrados.map((row) => ({ codigo: Number(row.BT_KM).toLocaleString('de-DE') + " km", total: row.BT_PVP_TOTAL }));

  useMemo(() => {
    if (pdfBlob) {
      const url = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Cotización.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [pdfBlob]);

  function formEsValido() {
    return nombre && !nombreError && identificacion && !identificacionError && email && !emailError && telefono && !telefonoError;
  }

  const generatePDF = (data) => {
    const styles = StyleSheet.create({
      titleBold: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 9,
        marginBottom: 10,
      },
      titleBoldUnic: {
        fontFamily: 'Helvetica-Bold',
      },
      page: {
        fontSize: 9,
        padding: 20,
        flexDirection: 'column',
      },
      content: {
        flex: 1,
      },
      title: {

        fontSize: 9,
        marginBottom: 10,
      },
      subtitle: {
        fontSize: 9,
        marginBottom: 5,
      },
      table: {
        display: 'table',
        width: 'auto',
        marginBottom: 10,
      },
      tableRow: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center'
      },
      tableCell: {
        padding: 5,
        borderWidth: 0,
        borderColor: '#000',
        width: '50%',

      },

      negrita: {
        fontWeight: 'bold'
      },

      tableCellA: {
        padding: 5,
        borderWidth: 0,
        borderColor: '#000',
        width: '50%',
        marginLeft: 50,
      },
      tableCellB: {
        padding: 5,
        borderWidth: 0,
        borderColor: '#000',
        width: '50%',
        marginRight: 5,
      },
      tableCellN: {
        padding: 5,
        borderWidth: 0,
        borderColor: '#000',
        fontWeight: 'bold',

      },
      logo: {
        width: 150,
        height: 20,
        marginRight: 10,
        marginBottom: 10
      },
      line: {
        borderBottomWidth: 2,
        borderBottomColor: '#112244',
        marginBottom: 13,
        width: '100%',
      },
      contentContainer: {
        borderWidth: 2,
        borderColor: '#112244', // Color del borde azul oscuro
        backgroundColor: '#FFFFFF', // Fondo blanco
        padding: 10,
        marginBottom: 20,
        borderRadius: 10,
      },
      contentTitle: {

        fontWeight: 'bold',

      },
      clientSection: {
        marginBottom: 20,
      },

      tableHeader: {
        padding: 5,
        borderWidth: 0,
        borderColor: '#000',
        fontWeight: 'bold',
      },

      footer: {

        width: '100%',
      },

      footerImage: {
        width: '100%',
      },

      header: {
        flexDirection: 'row',
        alignItems: 'center',
      },

      headerTextContainer: {
        marginLeft: 10,
        flex: 1,
      },

      greetingContainer: {
        alignItems: 'center',
        marginRight: 120
      },

      detailsContainer: {
      },

      greeting: {
        fontSize: 9,
        fontWeight: 'bold',
      },
      tableCellCenter: {
        marginLeft: 18
      },

      mTop: {
        marginTop: 20
      },

      mTop1: {
        marginTop: 15
      },

      mTop2: {
        marginTop: 8
      },

    });

    const TableRow = ({ codigo, total }) => (
      <View style={styles.tableRow}>
        <View style={styles.tableCell}><Text>{codigo}</Text></View>
        <View style={styles.tableCell}><Text>{total}</Text></View>
      </View>
    );

    const TableRowA = ({ codigo, items, total }) => (

      <View style={styles.tableRow}>
        <View style={styles.tableCell}><Text>{codigo}</Text></View>
        <View style={[styles.tableCellA, styles.tableCellCenter]}><Text>{items}</Text></View>
        <View style={styles.tableCellB}><Text>{total}</Text></View>
      </View>
    )

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const now = new Date();
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true,
    };

    let timestamp = now.toLocaleString('es-ES', options);
    let parts = timestamp.split(' ');

    parts = parts.map(part => {
      return isNaN(part) ? capitalizeFirstLetter(part) : part;
    });

    function formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // +1 porque los meses en JS van de 0 a 11
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }

    timestamp = parts.join(' ');
    const MyDocument = () => (
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.header}>
            <Image src={LogoHyundai} style={styles.logo} />
            <View style={styles.headerTextContainer}>
              <View style={[styles.greetingContainer, { alignItems: 'center' }]}>
                <Text style={styles.greeting}>Estimado(a) {data.nombre},</Text>
              </View>
              <View style={styles.detailsContainer}>
                <Text>A continuación detallamos la cotización solicitada por usted:</Text>
              </View>
            </View>
          </View>
          <View style={styles.line} />
          <View style={styles.clientSection}>
            <Text style={styles.titleBold}>COTIZACIÓN PARA MANTENIMIENTOS PREPAGADOS</Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, styles.tableCellN, styles.titleBoldUnic, { width: '20%', fontWeight: 'bold' }]}>CLIENTE:</Text>
                <Text style={[styles.tableCell, { width: '30%' }]}>{data.nombre}</Text>
                <Text style={[styles.tableCell, styles.tableCellN, styles.titleBoldUnic, { width: '20%' }]}>CÉDULA:</Text>
                <Text style={[styles.tableCell, { width: '30%' }]}>{data.identificacion}</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, styles.tableCellN, styles.titleBoldUnic, { width: '20%' }]}>EMAIL:</Text>
                <Text style={[styles.tableCell, { width: '30%' }]}>{data.email}</Text>
                <Text style={[styles.tableCell, styles.tableCellN, styles.titleBoldUnic, { width: '20%' }]}>TELÉFONO:</Text>
                <Text style={[styles.tableCell, { width: '30%' }]}>{data.telefono}</Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, styles.tableCellN, styles.titleBoldUnic, { width: '20%' }]}>FECHA:</Text>
                <Text style={[styles.tableCell, { width: '30%' }]}>{formatDate(new Date())}</Text>
              </View>

            </View>
          </View>
          <View style={styles.line} />
          <Text style={styles.titleBold}>DETALLE DE COSTOS</Text>
          <View style={styles.contentContainer}>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={styles.tableCell}>Modelo:</Text>
                <Text style={styles.tableCell}>{data.modeloAgrupador}</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCell}>Total mantenimientos:</Text>
                <Text style={styles.tableCell}>$ {((totalConBeneficios).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }))}</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, styles.titleBoldUnic]}>Precio final a pagar:</Text>
                <Text style={styles.tableCell}>$ {(totalSinBeneficios - (beneficios * 1.15)).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, styles.titleBoldUnic]}>Obtuviste un ahorro de:</Text>
                <Text style={styles.tableCell}>$ {(beneficios * 1.15 + totalBeneficiosAdicionales * 1.15).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, styles.titleBoldUnic]}>Descuento total:</Text>
                <Text style={styles.tableCell}>
                  {Math.round(((beneficios * 1.15 + totalBeneficiosAdicionales * 1.15) / totalConBeneficios) * 100)}%
                </Text>
              </View>
            </View>
          </View>
          <Text style={styles.titleBold}>DETALLE DE MANTENIMIENTOS</Text>
          {data.showMaintDetailsTable && (
            <View style={styles.contentContainer}>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <Text style={[styles.tableCell, styles.tableHeader, styles.titleBoldUnic]}>Mantenimiento</Text>
                  <Text style={[styles.tableCell, styles.tableHeader, styles.titleBoldUnic]}>Precio</Text>
                </View>
                {data.showMaintDetailsTable.map((row, i) => (
                  <TableRow key={i} codigo={row.codigo} total={`$ ${parseFloat(row.total).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`} />
                ))}
              </View>
            </View>
          )}
          <Text style={styles.titleBold}>BENEFICIOS ADICIONALES</Text>
          {data.showDetailsTable && (
            <View style={styles.contentContainer}>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, styles.tableHeader, styles.titleBoldUnic]}>Beneficio</Text>
                <Text style={[styles.tableCell, styles.tableHeader, styles.titleBoldUnic]}>Cantidad</Text>
                <Text style={[styles.tableCell, styles.tableHeader, styles.titleBoldUnic]}>Precio</Text>
              </View>
              <View style={styles.table}>
                {data.showDetailsTable.map((row, i) => (
                  <TableRowA style={styles.tableCell} key={i} codigo={row.codigo} items={Number(row.items).toFixed(0)} total={`$ ${parseFloat(row.total).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`} />
                ))}
              </View>
            </View>
          )}
          <View style={styles.footer}>
            <Image src={FooterImage} style={styles.footerImage} />
            <Text>Impreso: {timestamp}</Text>
            <Text style={[styles.title, styles.mTop1, styles.titleBoldUnic]}>BENEFICIOS:</Text>
            <View style={styles.benefitsList}>
              <Text style={styles.mTop2}>1. Congela el precio de los repuestos y ahorra hasta el 38% en mantenimientos preventivos.</Text>
              <Text style={styles.mTop2}>2. Uso de repuestos 100% originales.</Text>
              <Text style={styles.mTop2}>3. Reduce el riesgo de pérdida de garantía por falta de mantenimientos.</Text>
              <Text style={styles.mTop2}>4. Maximiza el valor comercial de tu Hyundai.</Text>
              <Text style={styles.mTop2}>5. Beneficio transferible a un segundo propietario.</Text>
              <Text style={styles.mTop2}>6. 10% de descuento en repuestos de mantenimiento correctivo y accesorios.</Text>
              {/*<Text style={styles.mTop2}>4. Descuento del {(Math.round((beneficios * 1.15 + totalSinBeneficiosDes) / (totalSinBeneficios + (beneficios * 1.15)) * 100))}% en los mantenimientos preventivos seleccionados, incluye mano de obra y repuestos.</Text>*/}
            </View>
          </View>
          <Text style={styles.mTop}>Proforma válida por 48 horas, precios sujetos a cambios sin previo aviso.</Text>
          <View style={[styles.line, styles.mTop1]} />
        </Page>
      </Document>
    );
    return MyDocument;
  };

  const renderDownloadLink = (MyDocument) => {
    return (
      <PDFDownloadLink document={<MyDocument />} fileName="cotizacion.pdf">
        {({ blob, url, loading, error }) => loading ? '' : ''}
      </PDFDownloadLink>
    );
  }

  const descargarPDF = async () => {
    const totalBeneficios = await obtenerBeneficios(mantenimientosSeleccionados.size, setBeneficiosData);
    const beneficiosRedondeados = Math.round(totalBeneficios * 100) / 100;
    const resultadoRedondeado = Math.round(totalMantenimientos * 1.15 * 100) / 100;
    const totalFinal = resultadoRedondeado - beneficiosRedondeados;
    const datosPDF = {
      total: totalFinal.toFixed(2),
      beneficios: beneficiosRedondeados.toFixed(2),
      totalSinBeneficios: resultadoRedondeado.toFixed(2),
      beneficiosData: showDetailsTable ? beneficiosData : [],
      mantenimientosFiltrados: showMaintDetailsTable ? mantenimientosFiltrados : [],
      nombre,
      email,
      identificacion,
      telefono,
      showDetailsTable,
      showMaintDetailsTable,
      modeloAgrupador
    };
    const MyDocument = generatePDF(datosPDF);
    setDatosPDF(datosPDF);
    const blob = await pdf(<MyDocument />).toBlob();
    setPdfBlob(blob);
  };

  const PDF = ({ data }) => {
    const [pdfLink, setPdfLink] = useState(null);
    useEffect(() => {
      if (data) {
        const MyDocument = generatePDF(data);
        setPdfLink(renderDownloadLink(MyDocument));
      }
    }, [data]);

    return (
      <div>
        {pdfLink}
      </div>
    );
  };

  return (
    <div>
      <div className='step4-container invoice' >
        <Row className='info-box'>
          <Col sm={12} md={6} className={` ${showDetails || showMaintDetails ? 'info-box-expandable  ' : ''}`}>
            <div className="info-item mt-3">
              <h4 className='title1  FontRegular'>Detalle de costos</h4>
            </div>
            <div style={{ marginTop: "10px" }}>
              {/*
              <div className="info-item">
                <div className="text FontLight">Precio normal mantenimientos:</div>
                <div className="price">$ {parseFloat(totalSinBeneficios.toFixed(2)).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</div>
              </div>
              <div className="info-item">
                <div className="text FontLight">Precio beneficios:</div>
                <div className="price">$ {(beneficios * 1.15).toFixed(2).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</div>
              </div>
              */}
              <div className="info-item">
                <div className="text FontLight">Total mantenimiento:</div>
                <div className="price">$ {((totalConBeneficios).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }))}</div>
              </div>
              <div className="info-item">
                <div className="text">Precio final a pagar:</div>
                <div className="price-highlight">$ {(totalSinBeneficios - (beneficios * 1.15)).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</div>
              </div>
              <hr className='hrwithe' />
              <div className="info-item">
                <div className="text">Obtuviste un Ahorro de:</div>
                <div className="price-highlight ">$ {(beneficios * 1.15 + totalBeneficiosAdicionales * 1.15).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</div>
              </div>
              <div className="info-item">
                <div className="text">Descuento total:</div>
                <div className="price-highlight">{Math.round(((beneficios * 1.15 + totalBeneficiosAdicionales * 1.15) / totalConBeneficios) * 100)}%</div>
              </div>
            </div>
          </Col>

          <Col sm={12} md={6} className='column-margin ' style={{ marginTop: "30px" }}>
            {modeloVehiculo && modeloVehiculo.imagen && (
              <div className="car-image-containerA car-container-margin">
                <img
                  src={
                    modeloVehiculo.imagen.startsWith('https://kerner.hyundai.com.ec/images/colores/')
                      ? modeloVehiculo.imagen.replace('https://kerner.hyundai.com.ec/images/colores/', '/colores/')
                    : modeloVehiculo.imagen.startsWith('https://kerner.hyundai.com.ec/images/spincar360/')
                      ? modeloVehiculo.imagen.replace('https://kerner.hyundai.com.ec/images/spincar360/', '/spincar360/')
                    : modeloVehiculo.imagen.startsWith('/static/media/')
                      ? modeloVehiculo.imagen.replace('/static/media/', '/colores/')
                    : modeloVehiculo.imagen.startsWith('https://www.hyundai.com.ec/static/media/')
                      ? modeloVehiculo.imagen.replace('https://www.hyundai.com.ec/static/media/', '/colores/')
                    : modeloVehiculo.imagen
                  }
                  alt="Carro"
                  className="car-image1"
                />

              </div>
            )}


          </Col>

        </Row>

        <Row>
          {/*
          <Col sm={6} md={6}>
            <Button
              variant="outline-primary"
              onClick={toggleDetails}
              className="button-style"
            >
              <FaGift />
              <span className='textb' >Detalle beneficios</span>
              <span className="chevron">
                {showDetails ? <FiChevronUp /> : <FiChevronDown />}
              </span>
            </Button>

            {showDetails &&
              <div className="info-item">
                <div className="details">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Descripción</th>
                        <th>Cantidad</th>
                        <th>Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      {beneficiosData.map((beneficio, index) => (
                        <tr key={index}>
                          <td>
                            {beneficio.BT_DESCRIPCION.charAt(0).toUpperCase() + beneficio.BT_DESCRIPCION.slice(1).toLowerCase()}
                          </td>
                          <td className="text-center">{String(beneficio.CANTIDAD).split('.')[0]}</td>
                          <td>$ {parseFloat(beneficio.BT_TOTAL).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="2">Valor de beneficios</td>
                        <td>$ {parseFloat(beneficios).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</td>
                      </tr>
                      <tr>
                        <td colSpan="2">Valor de beneficios (+IVA)</td>
                        <td>$ {parseFloat((beneficios * 1.15)).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            }
          </Col>
          */}
          <Col>
            <Button
              variant="outline-primary"
              onClick={toggleMaintDetails}
              className="button-style"
            >

              <MdBuild />
              <span className='textb'>Detalle mantenimientos</span>
              <span className='chevron'>
                {showMaintDetails ? <FiChevronUp /> : <FiChevronDown />}
              </span>
            </Button>

            {showMaintDetails &&
              <div className="info-item">
                <div className="details">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Mantenimiento</th>
                        <th>Precio</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mantenimientosFiltrados.map((mantenimiento, index) => (
                        <tr key={index}>
                          <td>{Number(mantenimiento.BT_KM).toLocaleString('de-DE')} km</td>
                          <td>${parseFloat(mantenimiento.BT_PVP_TOTAL).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</td>
                        </tr>
                      ))}
                      {/*
                      <tr>
                        <td>Total sin IVA</td>
                        <td>${parseFloat(totalMantenimientos.toFixed(2)).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</td>
                      </tr>
                      <tr>
                        <td>Total (+IVA)</td>
                        <td>${parseFloat((totalMantenimientos * 1.15).toFixed(2)).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</td>
                      </tr>
                      */}
                    </tbody>
                  </Table>
                </div>
              </div>
            }
          </Col>
        </Row>


        <Form style={{ marginTop: '50px' }}>
          <div>
            <Row style={{ alignItems: 'center' }}>
              <Col> <h4 className="invoice-title">Datos para cotización</h4></Col>
              <Col xs={12} sm={6} md={4}>

                <span>* Si eres asesor Hyundai, ingresa tu código aquí:</span>
              </Col>
              <Col xs={6} sm={2} md={2}>
                <Form.Control
                  className='higher-input'
                  type="text"
                  placeholder="CÓDIGO ASESOR"
                  value={asesor}
                  onChange={event => setAsesor(event.target.value)}
                />
              </Col>
            </Row>
          </div>
          <hr className="full-width-line" />
          <Row>
            <Col xs={12} md={6} >

              <Form.Group as={Row} className="mb-3 ">
                <Form.Label className='names FontRegular' column sm={4}>Nombre:</Form.Label>
                <Col sm={8}>
                  <Form.Control className="line-input" type="text" placeholder="Ingresa tu nombre" value={nombre} onChange={handleNombreChange} onBlur={handleNombreBlur} disabled={formularioEnviado} />
                  <span className="error-messageF">{nombreError}</span>
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-3 ">
                <Form.Label className='names FontRegular' column sm={4}>Cédula:</Form.Label>
                <Col sm={8}>
                  <Form.Control className="line-input" type="text" placeholder="Ingrese un número de cédula" value={identificacion} onChange={handleIdentificacionChange} onBlur={handleIdentificacionBlur} disabled={formularioEnviado} />
                  <span className="error-messageF">{identificacionError}</span>
                </Col>
              </Form.Group>

            </Col>

            <Col xs={12} md={6}>
              <Form.Group as={Row} className="mb-3">
                <Form.Label className='names FontRegular' column sm={4}>Correo Electrónico:</Form.Label>
                <Col sm={8}>
                  <Form.Control
                    className="line-input"
                    type="email"
                    placeholder="Ingrese un correo electrónico"
                    value={email}
                    onChange={handleEmailChange}
                    onBlur={handleEmailBlur}
                    onKeyDown={handleEmailKeyDown}
                    disabled={formularioEnviado}
                  />
                  <div className="email-suggestions">
                    {suggestions.map((suggestion, index) => (
                      <div
                        key={suggestion}
                        onClick={() => selectSuggestion(suggestion)}
                        className={index === focusedSuggestionIndex ? "active-suggestion" : ""}
                      >
                        {suggestion}
                      </div>
                    ))}
                  </div>
                  <span className="error-messageF">{emailError}</span>
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3">
                <Form.Label className='names FontRegular' column sm={4}>Teléfono:</Form.Label>
                <Col sm={8}>
                  <Form.Control className="line-input" type="text" placeholder="Ingrese un número de teléfono" value={telefono} onChange={handleTelefonoChange} onBlur={handleTelefonoBlur} disabled={formularioEnviado} />
                  <span className="error-messageF">{telefonoError}</span>
                </Col>
              </Form.Group>
            </Col>
          </Row>
        </Form>
        <CSSTransition in={enviado} classNames="mensaje" timeout={300} unmountOnExit>
          <div className="enviado-mensaje">
            <p>
              <strong>
                <em>Tu cotización fue enviada correctamente</em>
              </strong>
              <FiCheckCircle className="confirmation-icon ml-3" />
            </p>
          </div>
        </CSSTransition>
        {!enviado && (
          <Button
            onClick={guardarCotizacion}
            className="button-below6"
            disabled={!formEsValido()}

            style={
              (!formEsValido()) ?
                { backgroundColor: '#D3D3D3', color: '#808080', border: 'none' } :
                {}
            }
          >
            <FiSend style={{ marginLeft: '10px' }} /> Cotizar
          </Button>
        )}
        {enviado && (
          <Button className="button-below4 ml-3" onClick={handleNuevaCotizacion}>
            <FaFileAlt style={{ marginLeft: '10px' }} /> Realizar otra cotización
          </Button>
        )}
        <Button className="button-below5 ml-3"
          onClick={descargarPDF}
        >
          <FiDownload style={{ marginLeft: '10px' }} /> Descargar
        </Button>
        {datosPDF && (
          <PDF
            data={datosPDF}
            beneficiosData={beneficiosData}
            beneficios={beneficios}
            showDetailsTable={showDetailsTable}
            showMaintDetailsTable={showMaintDetailsTable}
          />
        )}
      </div>
      <Row>
        <Button
          className='back-button mt-3'
          onClick={yourBackFunction}>
          <FaAngleLeft />
          <span className='ml-1'>Regresar</span>
        </Button>
      </Row>
    </div>
  );
};

export default Step3;